<!-- @format -->

<ng-container *transloco="let t">
  <sis-common-attainment-details [attainment]="attainment" [secondaryAttainments]="secondaryAttainments">
    @if (expirationImminent) {
      <ng-template #expirationNotification>
        <sis-attainment-expiration-notification [attainment]="attainment"></sis-attainment-expiration-notification>
      </ng-template>
    }
    @if (attainment.rdiCredits || (attainment?.assessmentItemId | assessmentItem | async)?.rdiCreditsEnabled === "ENABLED") {
      <ng-template #rdiCredits>
        <div class="form-group-mimic" role="listItem">
          <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.RDI_CREDITS") }}</dt>
          <dd>{{ attainment?.rdiCredits ?? "-" }}</dd
          ><dd> </dd
        ></div>
      </ng-template>
    }
    <ng-template #registrationDetails>
      <div class="form-group-mimic" role="listitem">
        <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.REGISTRATION_DATE") }}</dt>
        <dd>{{ attainment.registrationDate | localDateFormat }}</dd>
      </div>
    </ng-template>

    <ng-template #assessmentDetails>
      <h3>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.HEADINGS.ASSESSMENT_DETAILS") }}</h3>
      @if ({ studentAssessmentInfo: $studentAssessmentInfoForCur | async }; as data) {
        <dl>
          <div class="form-group-mimic full-width" role="listitem">
            <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.ASSESSMENT_CRITERIA") }}</dt>
            <dd>{{ data.studentAssessmentInfo?.finalEvaluation?.assessmentCriteriaText ?? "-" }}</dd>
          </div>
          <div class="form-group-mimic full-width" role="listitem">
            <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.FEEDBACK_SESSION") }}</dt>
            @if (data.studentAssessmentInfo?.finalEvaluation?.feedbackSession; as feedbackSession) {
              <dd> {{ feedbackSession.dateTime | localDateTimeFormat }}, {{ feedbackSession.location }} </dd>
            } @else {
              <dd> - </dd>
            }
          </div>
          <div class="form-group-mimic full-width" role="listitem">
            <dt>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.VERBAL_FEEDBACK") }}</dt>
            <dd>{{ data.studentAssessmentInfo?.assessment?.verbalFeedback ?? "-" }}</dd>
          </div>
        </dl>
      }
    </ng-template>
  </sis-common-attainment-details>
</ng-container>
